/* cooldown para la ultima vez que se hizo una compra */
import { useState, useEffect } from 'react';

export const useCooldown = (cooldownPeriod = 1 * 60 * 1000) => {
  const [cooldownActive, setCooldownActive] = useState(false);
  const [cooldownRemaining, setCooldownRemaining] = useState(0);

  useEffect(() => {
    const lastLinkTimestamp = localStorage.getItem('lastPaymentLinkCreated');

    if (lastLinkTimestamp) {
      const now = Date.now();
      const lastTime = parseInt(lastLinkTimestamp);
      const timeElapsed = now - lastTime;

      if (timeElapsed < cooldownPeriod) {
        setCooldownActive(true);
        setCooldownRemaining(Math.ceil((cooldownPeriod - timeElapsed) / 1000));
      } else {
        setCooldownActive(false);
        setCooldownRemaining(0);
      }
    }
  }, [cooldownPeriod]);

  useEffect(() => {
    let timer;
    if (cooldownActive && cooldownRemaining > 0) {
      timer = setInterval(() => {
        setCooldownRemaining(prev => {
          if (prev <= 1) {
            setCooldownActive(false);
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [cooldownActive, cooldownRemaining]);

  const startCooldown = () => {
    localStorage.setItem('lastPaymentLinkCreated', Date.now().toString());
    setCooldownActive(true);
    setCooldownRemaining(cooldownPeriod / 1000);
  };

  const formatRemainingTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return {
    cooldownActive,
    cooldownRemaining,
    startCooldown,
    formatRemainingTime
  };
};